import BaseStore from 'fluxible/addons/BaseStore';
import Actions from "../constants/Actions";

class HomeStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.website = [];
    this.product = [];
    this.service = [];
    this.trending = [];
    this.popular = [];
    this.userfavourite = [];
    this.entity = [];
  }

  handleWebsiteLoadSuccess(data) {
    this.website = data;
    this.emitChange();
  }
  handleProductLoadSuccess(data) {
    this.product = data;
    this.emitChange();
  }
  handleServiceLoadSuccess(data) {
    this.service = data;
    this.emitChange();
  }
  handleTrendingLoadSuccess(data) {
    this.trending = data;
    this.emitChange();
  }
  handlePopularTopics(data) {
    this.popular = data;
    this.emitChange();
  }
  handleUserfavourite(data) {
    this.userfavourite = data.data;
    this.emitChange();
  }
   handleuserfeedbackEntity(data){
    this.entity = data;
    this.emitChange();
  }
  handleWebsiteMoreLoadSuccess(data) {
    for (var obj in this.website) {
      if (this.website[obj].name == data.name) {
        this.website[obj].entitiesList = data.entitiesList;
      }
    }
    this.emitChange();
  }
  handleProductMoreLoadSuccess(data) {
    for (var obj in this.product) {
      if (this.product[obj].name == data.name) {
        this.product[obj].entitiesList = data.entitiesList;
      }
    }
    this.emitChange();
  }

  handleServiceMoreLoadSuccess(data) {
    for (var obj in this.service) {
      if (this.service[obj].name == data.name) {
        this.service[obj].entitiesList = data.entitiesList;
      }
    }
    this.emitChange();
  }
  get() {
    return {
      // website: this.website,
      // product: this.product,
      // service: this.service,
      // trending: this.trending,
      // popular: this.popular,
      // userfavourite: this.userfavourite,
      entity: this.entity,
    };
  }

  dehydrate() {
    return {
      // website: this.website,
      // product: this.product,
      // service: this.service,
      // trending: this.trending,
      // popular: this.popular,
      // userfavourite: this.userfavourite,
      entity: this.entity,
    };
  }

  rehydrate(state) {
    // this.website = state.website;
    // this.product = state.product;
    // this.service = state.service;
    // this.trending = state.trending;
    // this.popular = state.popular;
    // this.userfavourite = state.userfavourite;
    this.entity = state.entity;
  }
}

HomeStore.storeName = 'HomeStore';
HomeStore.handlers = {
  [Actions.LOAD_HOMEWEBSITE_SUCCESS]: 'handleWebsiteLoadSuccess',
  [Actions.LOAD_HOMEPRODUCT_SUCCESS]: 'handleProductLoadSuccess',
  [Actions.LOAD_HOMESERVICE_SUCCESS]: 'handleServiceLoadSuccess',
  [Actions.LOAD_WEBSITEMORE_SUCCESS]: 'handleWebsiteMoreLoadSuccess',
  [Actions.LOAD_PRODUCTMORE_SUCCESS]: 'handleProductMoreLoadSuccess',
  [Actions.LOAD_SERVICEMORE_SUCCESS]: 'handleServiceMoreLoadSuccess',
  [Actions.LOAD_HOMETRENDING_SUCCESS]: 'handleTrendingLoadSuccess',
  [Actions.LOAD_POPULARTOPICS_SUCCESS]: 'handlePopularTopics',
  [Actions.LOAD_USERFAVOURITE_SUCCESS]: 'handleUserfavourite',
  [Actions.LOAD_USERFEEDBACK_SUCCESS]: 'handleuserfeedbackEntity',

};

export default HomeStore;


// WEBPACK FOOTER //
// ./src/stores/HomeStore.js